<script>
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import Button from './Button.svelte';
  import { getDialTrad,getTrad } from './js/AppState';
  import SGMSApi from './js/SGMSApi';
  import TerminalIcon from './TerminalIcon.svelte';


  export let ids


  var showContent = false
  var showTitle = false
  let showBtn = false

  let dialIndex = 0

  $: ended = dialIndex >= ids.length - 1

  onMount(() => {
    showTitle = true
  });

  $: id = ids[dialIndex]
  $: dial = $getDialTrad(id)
  $: title = dial.title
  $: content = dial.content

  $: {
    SGMSApi.sendContentEvent(id, "SHOW")
  }

  function nextDial() {
    dialIndex = dialIndex + 1
    showTitle = true
  }

  function typewriter(node, { speed = CONFIG.typewriter_delay }) {
		const valid = ( node.childNodes.length === 1 && node.childNodes[0].nodeType === 3 )
		if (!valid) {
			throw new Error(`This transition only works on elements with a single text node child`);
		}
		const text = node.textContent;
		const duration = text.length * speed;
		return {
			duration,
			tick: t => {
				const i = ~~(text.length * t);
				node.textContent = text.slice(0, i);
			}
		};
  }

  function onIntroEnd() {
    setTimeout(() => {
      showContent = true
    }, 400)
  }

  function hideTitle() {
    showTitle = false
    showContent = false
    showBtn = false
  }

  function showNextBtn() {
    showBtn = true
  }


</script>

<TerminalIcon />

{#if dialIndex !== null}
  <div id="dial" in:fade >

    <div class="text">
      {#if showTitle}
        <div
          class="title"
          in:typewriter
          on:introend={onIntroEnd}
          out:fade={{duration: 120}}
          on:outroend={nextDial}>
            {title}
        </div>
      {/if}
      {#if showContent}
        <div
          class="content"
          in:typewriter
          out:fade={{duration: 120}}
          on:introend={showNextBtn}>
            {content}
        </div>
      {/if}
    </div>

    {#if showBtn}
      <div class="button-ctnr" in:fade={{duration: 120}} >
        {#if !ended}
          <Button name="ButtonNextDial" on:click={hideTitle}>{$getTrad("next_btn")}</Button>
        {:else}
          <slot></slot>
        {/if}
      </div>
    {/if}
  </div>
{/if}

<style>

#dial {
  font-size: 1.5em;
  max-width: 600px;
  /* border: 1px solid  red; */
  padding-right: 10px;
  user-select: none;
 }

/* .text { min-height: 200px; } */
.title { font-weight: bold; }
.button-ctnr { margin-top: 35px; }

@media screen and (max-width: 800px) {
  .button-ctnr { margin-top: 30px; }
}

</style>
